/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%] {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  max-width: 1670px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/main/main.component.scss.shim.ngstyle.js.pre-build-optimizer.js